.card {
    max-width: 360px;

    @media (width < 768px) {
        width: 100%;
        min-width: 300px;
    }

    &.notOpenForApplicants {
        opacity: 0.5;
        pointer-events: none;
    }
}

.cardTitle {
    @media (width < 1024px) {
        font-size: 1rem;
    }
}

.cardHeaderSubLabel {
    color: var(--bi-neutral-60);
    @media (width < 1024px) {
        font-size: 0.75rem;
    }
}

.chipsContainer {
    display: flex;
    flex-wrap: wrap;
    gap: var(--bi-scale-2x) var(--bi-scale-1x);
}

.addButton {
    margin: auto auto 0 auto;
}

.addedToCartText {
    display: flex;
    justify-content: center;
    align-items: anchor-center;
    width: 100%;
    gap: var(--bi-scale-1x);
    font-size: 1rem;
    font-weight: 700;
    padding: 10px;
    margin: auto auto 0 auto;
}
